import templateConfig from '@templateConfig';

type Locales = (typeof templateConfig.localization.locales)[number];
export type Locale = Locales['router'];
export type Territory = Locales['territory'];
export type ContentfulLocale = Locales['contentful'];

export type LocalesObjType = {
  [K in Locales as K['router']]: K;
};

export type TerritoryObjType = {
  [K in Locales as K['router']]: K['territory'];
};

export type ContentfulLocalesObjType = {
  [K in Locales as K['router']]: K['contentful'];
};

export const LOCALES_OBJ: LocalesObjType =
  templateConfig.localization.locales.reduce(
    (acc, locale) => ({
      ...acc,
      [locale.router]: locale,
    }),
    {} as LocalesObjType
  );

export const LOCALES: Locale[] = templateConfig.localization.locales.reduce(
  (acc: Locale[], locale) => [...acc, locale.router],
  []
);

export const isValidLocale = (someLocale: string): boolean =>
  (LOCALES as string[]).includes(someLocale);

export const pathStartsWithLocale = (path: string): boolean =>
  path.length > 3 &&
  path.charAt(0) === '/' &&
  path.charAt(3) === '/' &&
  isValidLocale(path.substring(1, 3));

export const stripLocaleFromPathIfPresent = (path: string) =>
  pathStartsWithLocale(path) ? path.slice(3) : path;

/**
 * This is the locales used in Contentful.
 */
export const CONTENTFUL_LOCALES_OBJ: ContentfulLocalesObjType =
  templateConfig.localization.locales.reduce(
    (acc, locale) => ({
      ...acc,
      [locale.router]: locale.contentful,
    }),
    {} as ContentfulLocalesObjType
  );

export const CONTENTFUL_LOCALES: ContentfulLocale[] = Object.values(
  CONTENTFUL_LOCALES_OBJ
);

export const DEFAULT_LOCALE = templateConfig.localization.defaultRouterLocale;

export const TERRITORIES_OBJ: TerritoryObjType =
  templateConfig.localization.locales.reduce(
    (acc, locale) => ({
      ...acc,
      [locale.router]: locale.territory,
    }),
    {} as TerritoryObjType
  );

export const TERRITORIES: Territory[] = Object.values(TERRITORIES_OBJ);
